import classnames from 'classnames'
import { extendTailwindMerge } from 'tailwind-merge'
import { createTV } from 'tailwind-variants'

/**
 * Tailwind-merge only knows Tailwind's stock scale, so a custom size like `text-h2` reads to it
 * as a colour and it drops a real `text-white` as a conflict. That merge runs in two places —
 * inside every `tv()` and inside `cn()` — so both are built from this one config.
 *
 * Keep the lists equal to the `fontSize` and `borderRadius` keys in tailwind.config.js.
 */
const twMergeConfig = {
	extend: {
		classGroups: {
			'font-size': [
				{
					text: [
						'h1',
						'h2',
						'h3',
						'h4',
						'h5',
						'h6',
						'h7',
						'display',
						'display-lg',
						'display-md',
						'display-sm',
						'body0',
						'body1',
						'body2',
						'body3',
					],
				},
			],
			rounded: [{ rounded: ['brand', 'note', 'thumb'] }],
		},
	},
}

const twMerge = extendTailwindMerge(twMergeConfig)

/** The `tv` every `*.styles.ts` uses. Never import it from 'tailwind-variants' directly. */
export const tv = createTV({ twMergeConfig })

export function cn(...inputs: classnames.ArgumentArray) {
	return twMerge(classnames(inputs))
}
